export default __webpack_public_path__ + "static/4,2mm_lense_8015-6014_night-e1992729a02168cf2caca2365b74a12f.webp";